import Grid from '../components/grid'
import Container from '../components/ui/container'
import Text from '../components/ui/text'
import Image from 'next/image'
import { Page } from '@telesoft/types/payload-types'
import React, { ReactElement } from 'react'
import { ASSET_URL } from '@telesoft/lib/web/constants'

export type BlockProps = Extract<Page['blocks'][0], { blockType: 'product-lifecycle' }>

export default function ProductLifecycle(block: BlockProps): ReactElement {
  const { title, subTitle, columns, image } = block
  return (
    <Container>
      <Grid className="bg-heading text-white p-8 md:p-12 lg:p-20">
        <div className="col-span-full md:col-span-4 lg:col-span-4 text-white flex flex-col justify-start items-start">
          <h5 className="text-white opacity-50">{subTitle}</h5>
          <Text variant="mediumHeading" className="text-white">
            {title}
          </Text>
        </div>

        {columns &&
          columns.top?.map((column: any) => {
            return (
              <div
                key={`column-description-map--${column.id}`}
                className="col-span-4 flex flex-col justify-start items-start"
              >
                <h5 className="text-white mb-4 opacity-50 font-medium tracking-widest">
                  {column.title}
                </h5>
                <div className="min-h-[1px] bg-white w-full mb-4" />

                <Text variant="body" className="text-white">
                  {column.description}
                </Text>
              </div>
            )
          })}

        <div className="col-span-full min-h-[42px] bg-black relative w-full my-2 md:my-6 lg:my-8 xl:my-12">
          <div className="absolute z-10 mix-blend-overlay inset-0 bg-gradient-to-r from-transparent to-telesoft"></div>
          {/* <Asset resource={image as AssetType} imgClassName="object-cover object-center" fill /> */}
          <Image
            src={
              typeof image !== 'string' && image?.filename
                ? ASSET_URL + '/' + image.filename
                : '/assets/images/telesoft-abstract-11.jpeg'
            }
            loading="lazy"
            alt={(typeof image !== 'string' && image?.alt) || ''}
            className="object-cover object-center"
            layout="fill"
          />
        </div>

        {columns &&
          columns.bottom?.map((column: any) => {
            return (
              <div
                key={`column-description-map--${column.id}`}
                className="col-span-4 flex flex-col justify-start items-start"
              >
                <h5 className="text-white mb-4 opacity-50 font-medium tracking-widest">
                  {column.title}
                </h5>
                <div className="min-h-[1px] bg-white w-full mb-4" />

                <Text variant="body" className="text-white">
                  {column.description}
                </Text>
              </div>
            )
          })}
      </Grid>
    </Container>
  )
}
